import { FeatureFlags } from '~/modules/feature_flags';

// TODO(W-24459316): Verify the Search team's paidprivateoffer v3 contract is deployed before enabling ff-private-offer-filters.
export const PRIVATE_OFFER_PRICE_FILTER_VALUE = 'paidprivateoffer';

export const getEnabledPriceFilters = (values: string[] | undefined): string[] | undefined => {
    if (FeatureFlags.FF_PRIVATE_OFFER_FILTERS || !values?.includes(PRIVATE_OFFER_PRICE_FILTER_VALUE)) {
        return values;
    }
    const enabledValues = values.filter((value) => value !== PRIVATE_OFFER_PRICE_FILTER_VALUE);
    return enabledValues.length ? enabledValues : undefined;
};
